module.exports = __webpack_public_path__ + "static/img/samajuri (20).0ca9222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (20).jpg
// module id = 1Pme
// module chunks = 0